const months_enUS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
].map((m) => m.toLowerCase())

class AgeValidation extends HHBaseElement {
  static counter = 0
  constructor() {
    super(`
      <slot></slot>
    `)
    this.id = `age-validator-${AgeValidation.counter++}`
    this._init()
  }

  _init() {
    const input = document.createElement('input')
    input.type = 'date'
    input.id = this.id
    input.name = 'age-validator'
    input.required = this.isRequired
    input.classList.add('visually-hidden')
    input.setAttribute('aria-hidden', true)
    input.addEventListener('invalid', this.showErrors.bind(this))
    input.setAttribute('hidden', true)

    const validatorField = document.createElement('input')
    validatorField.type = 'text'
    validatorField.name = 'age-validator-checkbox'
    validatorField.required = this.isRequired
    validatorField.id = `${this.id}-checkbox`
    validatorField.style.display = 'none'
    validatorField.classList.add('visually-hidden')
    validatorField.setAttribute('aria-hidden', true)
    validatorField.addEventListener('invalid', this.showErrors.bind(this))
    this.appendChild(validatorField)
    this.appendChild(input)
  }

  get isRequired() {
    return this.dataset.required === 'true'
  }

  get minDate() {
    const minDate = new Date()
    minDate.setFullYear(minDate.getFullYear() - this.minAge)
    return minDate
  }

  get minAge() {
    return !!this.dataset.minAge ? parseInt(this.dataset.minAge) : 16
  }

  get monthField() {
    return this.querySelector(`[name="${this.dataset.monthField}"]`)
  }

  get dayField() {
    return this.querySelector(`[name="${this.dataset.dayField}"]`)
  }

  get yearField() {
    return this.querySelector(`[name="${this.dataset.yearField}"]`)
  }

  get dateInput() {
    return this.querySelector(`#${this.id}`)
  }

  get validityCheckbox() {
    return this.querySelector(`#${this.id}-checkbox`)
  }

  connectedCallback() {
    if (this.monthField) {
      this.monthField.addEventListener('change', this._updateDate.bind(this))
    }
    if (this.dayField) {
      this.dayField.addEventListener('change', this._updateDate.bind(this))
    }

    if (this.yearField) {
      this.yearField.addEventListener('change', this._updateDate.bind(this))
    }

    if(this.isRequired) {
      this.closest('form').addEventListener(
        'submit',
        this._handleSubmission.bind(this)
      )
    }

    setTimeout(() => {
      this.initialized = true
    }, 500)
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d)
  }

  _handleSubmission() {
    this._checkValidity()
  }

  _formatDateForInput(date) {
    const day = ('0' + date.getDate()).slice(-2)
    const month = ('0' + (date.getMonth() + 1)).slice(-2)

    return date.getFullYear() + '-' + month + '-' + day
  }

  _updateDate(e) {
    const month = this.monthField.value
    const day = this.dayField.value

    if(this.yearField) {
      const year = this.yearField.value

      if (month && day && year) {
        const date = new Date(
          `${year}-${String(months_enUS.indexOf(month) + 1).padStart(
            2,
            '0'
          )}-${String(day).padStart(2, '0')}`
        )
        this.dateInput.value = this._formatDateForInput(date)
      }
    } else {
      if (month && day) {
        const date = new Date(
          `${String(months_enUS.indexOf(month) + 1).padStart(
            2,
            '0'
          )}-${String(day).padStart(2, '0')}`
        )
        this.dateInput.value = this._formatDateForInput(date)
      }
    }

    this._checkValidity()
  }

  showErrors() {
    if (!this.initialized) return
    if (this.querySelector('.error')) {
      return this.scrollIntoView({ block: 'center', inline: 'nearest' })
    }

    const error = document.createElement('div')
    error.classList.add('error')
    error.innerHTML = `
      <small class='form__message text-left color-error-red'>${this.dataset.errorMessage}</small>
    `
    this.appendChild(error)
  }

  hideErrors() {
    this.querySelector('.error')?.remove()
  }

  _checkValidity() {
    const date = new Date(this.dateInput.value)

    if (this.isValidDate(date)) {
      const minDate = this.minDate
      const isValid = date < minDate
      if (isValid) {
        this.validityCheckbox.value = 'true'
        this.hideErrors()
      } else {
        this.validityCheckbox.value = ''
        this.showErrors()
        setTimeout(() => {
          this.scrollIntoView({ block: 'center', inline: 'nearest' })
        }, 100)
      }
    } else {
      this.showErrors()
      this.validityCheckbox.value = ''
    }
  }
}

window.customElements.define('age-validation', AgeValidation)
